import api from '@shared/api';

import {DictionarySearchResponse, ViolationSearchResponse, ViolationsSearchPayload} from './types';

const VIOLATIONS_PATH = 'dda/api/v1';
const NSI_PATH = 'dda-trs-nsi-api/api/v1';

export const fetchViolations = async (payload: ViolationsSearchPayload) =>
    (await api.post<ViolationSearchResponse>(`${VIOLATIONS_PATH}/violation/search`, payload)).data;

export const fetchViolationTypes = async () =>
    (
        await api.post<DictionarySearchResponse>(`${NSI_PATH}/dict_violation_type/search`, {
            page: {page: 0, size: 10000},
        })
    ).data;

export const fetchViolationStatuses = async () =>
    (
        await api.post<DictionarySearchResponse>(
            `${VIOLATIONS_PATH}/dict_violation_status/search`,
            {
                page: {page: 0, size: 10000},
            },
        )
    ).data;

export const fetchNotificationStatuses = async () =>
    (
        await api.post<DictionarySearchResponse>(`${NSI_PATH}/dict_notification_status/search`, {
            page: {page: 0, size: 10000},
        })
    ).data;
